import type { EDSLayoutSlots } from '@/types/eds/EDSLayoutSlots';

// to merge objects with the same slot names
export function mergeSlots<SlotEnum extends string>(...slots: EDSLayoutSlots<SlotEnum>[]): EDSLayoutSlots<SlotEnum> {
  const result: EDSLayoutSlots<SlotEnum> = {};

  slots.forEach((slotRecord) => {
    Object.keys(slotRecord).forEach((slotName) => {
      const slotValue = slotRecord[slotName];

      if (slotName === 'categories') {
        if (!('categories' in result)) result.categories = {} as any;
        result.categories = { ...result.categories, ...slotValue };
      } else if (Array.isArray(slotValue)) {
        if (!(slotName in result)) result[slotName] = [];
        result[slotName] = [...result[slotName], ...slotValue];
      }
    });
  });

  return result;
}
